import { FieldPath, FieldValues, RegisterOptions, useFormContext } from "react-hook-form";

import { FilterableSinglePickerFormField } from "src/components/Form/FilterableSinglePickerFormField";
import { useGetIdentifiersQuery } from "src/graphql/anti-fraud/queries/rules/IdentifiersQuery.ts";

export type IdentifierFilterableSinglePickerFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  id: string;
  label?: string;
  helperText?: string;
  placeholder?: string;
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  name: TName;
  caseTypeCode?: string;
};

export function IdentifierFilterableSinglePickerFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  id,
  name,
  rules,
  label,
  helperText,
  placeholder,
  caseTypeCode,
}: IdentifierFilterableSinglePickerFormFieldProps<TFieldValues, TName>) {
  const { setError, control } = useFormContext<TFieldValues, TName>();

  const { data: items, loading } = useGetIdentifiersQuery({
    onError: (error) => setError(name, error),
    caseTypeCode,
  });

  return (
    <FilterableSinglePickerFormField
      id={id}
      control={control}
      name={name}
      rules={rules}
      label={label}
      helperText={helperText}
      options={items}
      getOptionLabel={(item) => `${item.elementName} - ${item.identifierName}`}
      getOptionValue={(item) => `${item.identifierCode}-${item.elementCode}`}
      loading={loading}
      placeholder={placeholder}
    />
  );
}
